export function isDefined(value: any) {
  return (value !== undefined && value !== null);
}

export function doMany(actions) {
  actions.forEach(action => action());
}

export function promptSaveDataToFile(data, fileName) {
  // Inspirer: https://medium.com/@drevets/you-cant-prompt-a-file-download-with-the-content-disposition-header-using-axios-xhr-sorry-56577aa706d6
  // TODO: think if there's a cleaner way to "prompt save fetch / axios response to file" — N2FEaB8n
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

export function formatBytes(bytes, decimals = 2) {
  // First got from: ChatGPT conversation "https://chat.openai.com/chat/d3cc689d-679d-4816-92cc-8f339d30807b"
  if (bytes === 0) return '0 Bytes'
  
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}


export function handleImgError(e: Event) {
  const img = e.target as HTMLImageElement
  img.style.display = 'none'
}

export function getKeyByValue(object, value) {
  // First got from: https://stackoverflow.com/a/28191966/3503851
  return Object.keys(object).find(key => object[key] === value);
}


// TODO: think about how to make the time format more readable — N2A5ipA4
  // May be including AM/PM
export function currentTimeFormatted() {
  const currenTime = new Date;
  const ct = currenTime;
  const h = ct.getHours();
  const m = ct.getMinutes();
  const s = ct.getSeconds();
  const ms = ct.getMilliseconds();
  const currentTimeStr = `${h}:${m}:${s}.${ms}`;
  return currentTimeStr;
}

export function format24TimeToAMPM(inputTime: string) {
  // formats 24-hour time to 12-hour time (with AM/PM)
  const [hours, minutes, seconds] = inputTime.split(":");
  const parsedHours = Number(hours);
  const ampm = parsedHours >= 12 ? "PM" : "AM";
  const formattedHours = (parsedHours % 12 || 12).toString().padStart(2, "0");
  const formattedMinutes = minutes.padStart(2, "0");
  const formattedSeconds = seconds.padStart(2, "0");
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
}

// Convert local date and time to UTC
export function convertLocalDataAndTimeToUtc(date: string, time: string) {
  const localDate = new Date(date + 'T' + date);
  const utcDate = new Date(localDate.getTime());
  return utcDate.toISOString();
}

export function prepareImportedPaths(pathsContainer: any) {
  const isObject = typeof pathsContainer === 'object' && !Array.isArray('object');
  
  let newPathsContainer;
  
  if(isObject) {
    newPathsContainer = {} as any;
    for (const [key, value] of Object.entries(pathsContainer)) {
      const path = value;
      newPathsContainer[key] = prepareImportedPath(path);
    }
  } // TODO: if needed later, add support for arrays

  return newPathsContainer;
}

export function prepareImportedPath(path: string) {
  const newPath = path.replace(/(?<=\/)@fs\//,'');
  return newPath;
}


export function wrapPathsAsCssUrls(pathsContainer: any) {
  const isObject = typeof pathsContainer === 'object' && !Array.isArray('object');
  
  let newPathsContainer;
  
  if(isObject) {
    newPathsContainer = {} as any;
    for (const [key, value] of Object.entries(pathsContainer)) {
      const path = value;
      newPathsContainer[key] = wrapPathAsCssUrl(path);
    }
  } // TODO: if needed later, add support for arrays

  return newPathsContainer; 
}

export function wrapPathAsCssUrl(path: string) {
  const newPath = path.replace(/^(.*)$/,'url($1)');
  return newPath;
}

export function prepareImportedPathsAsCssUrls(pathsContainer: any) {
  const newPathsContainer = prepareImportedPaths(pathsContainer);
  const newPathsWrappedAsCssUrlsContainer = wrapPathsAsCssUrls(newPathsContainer);
  return newPathsWrappedAsCssUrlsContainer;
}



const elapsedTimeSessions = {} as any;   // helper for elapsedTimeSinceLast
export function elapsedTimeSinceLast(key:string) {
  // initiate session if not yet initiated
  if (!elapsedTimeSessions[key]) {
    elapsedTimeSessions[key] = {
      previous: 0,     // elapsed since timeorigin till last measurement
      now: 0,     // elapsed since timeorigin till this measurement
    }
  }

  // set "previous" to the "previous now"
  elapsedTimeSessions[key].previous = elapsedTimeSessions[key].now;

  // set "now" to the current time
  elapsedTimeSessions[key].now = performance.now();

  // finalize and return the elapsed time since last measurement
  const elapsedTimeSinceLast = elapsedTimeSessions[key].now - elapsedTimeSessions[key].previous;

  const elapsedTimeSinceLast_formatted = elapsedTimeSinceLast/1000 < 1
      ? elapsedTimeSinceLast.toFixed(1)+'ms'
      : Math.floor(elapsedTimeSinceLast/1000)+'s '+(elapsedTimeSinceLast%1000).toFixed(1)+'ms';
  
  return elapsedTimeSinceLast_formatted;
}


export async function getImageSize(file: File) {
  // create a new FileReader object
  const reader = new FileReader();

  // create a Promise to resolve when the reader has finished loading the file
  const fileReaderLoadPromise = new Promise(function(resolve, reject) {
    reader.onload = resolve;
    reader.onerror = reject;
  });

  // read the file as a data URL
  reader.readAsDataURL(file);

  // wait for the reader to finish loading the file
  await fileReaderLoadPromise;

  // create a new Image object
  const img = new Image();

  // create a Promise to resolve when the image has finished loading
  const imgLoadPromise = new Promise(function(resolve, reject) {
    img.onload = resolve;
    img.onerror = reject;
  });

  // set the source of the image to the data URL
  img.src = reader.result as string;

  // wait for the image to finish loading
  await imgLoadPromise;

  // get the height and width of the image
  const height = img.height;
  const width = img.width;

  return { height, width };
}


export async function getVideoSizeAndDuration(file: File) {
  // Notes
    // inspirer: https://stackoverflow.com/a/51696339/3503851
  
  const url = URL.createObjectURL(file)
  const video = document.createElement('video')
  video.onloadedmetadata = evt => {
    // Revoke when you don't need the url any more to release any reference
    URL.revokeObjectURL(url)
    console.log(video.videoWidth, video.videoHeight)
  }
  video.src = url
  video.load() // fetches metadata



  // const url = URL.createObjectURL(file)
  // const video = document.createElement('video')
  // const videoLoadPromise = new Promise(function(resolve, reject) {
  //   video.onloadedmetadata = resolve;
  //   video.onerror = reject;
  //   video.load() // fetches metadata
  // });

  // video.src = url
  // await videoLoadPromise;

  // URL.revokeObjectURL(url);
  const height = video.videoHeight;
  const width = video.videoWidth;
  const duration = 0 /* video.duration */;
  
  return { height, width, duration };
}

export function isImage(file: File) {
  const fileType = file.type;
  return fileType.startsWith('image/')
}

export function isVideo(file: File) {
  const fileType = file.type;
  return fileType.startsWith('video/')
}

export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export function joinPaths(...segments: string[]) {
  const nonEmptySegments = segments.filter(segment => segment);
  const joinedPath = nonEmptySegments.join('/');
  return joinedPath.replace(/\/+/g, '/');
}


// ------------ string utils ------------
export function toTitleCase(str :string) {
  return str
      .toLowerCase() 
      .split(' ') 
      .map((word :string) => word.charAt(0).toUpperCase() + word.slice(1) ) // Capitalize the first letter of each word
      .join(' '); 
}

export function getBoldSubstring(string: any, substringToBold: any) {
  return string.toLowerCase().replaceAll(substringToBold.toLowerCase(), `<b>${substringToBold.toLowerCase()}</b>`)
}

export function getUniqueItems(someArray: (string|number)[]) {
  const uniqueItems = [...new Set(someArray)];
  return uniqueItems;
}

export function isEqualLowerCased(str1: string, str2: string) {
  return str1.toLowerCase() === str2.toLowerCase();
}

export function isIncludeLowerCased(str: string, substring: string) {
  return str.toLowerCase().includes(substring.toLowerCase())
}

export function getInitials(name: string) {
  return name
    .split(' ')                // Split by spaces
    .map(word => word[0])      // Get the first letter of each word
    .join('')                  // Join all initials together
    .toUpperCase();            // Make them uppercase
}


// ------------ timing/scheduling utils ------------
/**
 * Creates a throttled function that ensures the function is executed at most once every `limit` ms.
 * If the function is called during the throttle period, it will be executed once more after the delay (trailing execution).
 *
 * @param fn - The function to throttle.
 * @param limit - The time interval in milliseconds.
 * @returns A new throttled function.
 *
 * @example
 * const log = throttle(() => console.log('Throttled!'), 1000);
 * window.addEventListener('scroll', log); // Executes at most once per second, with a final execution if needed.
 */
export function throttle<T extends (...args: any[]) => any>(
  fn: T,
  limit: number
): (...args: Parameters<T>) => void {
  let lastCall = 0;
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let lastArgs: Parameters<T> | null = null;
  let isRunning = false;

  return (...args: Parameters<T>) => {
    const now = Date.now();

    const invoke = async () => {
      lastCall = Date.now();
      isRunning = true;
      await Promise.resolve(fn(...args)); // Handles both sync & async
      isRunning = false;
    };

    if (now - lastCall >= limit && !isRunning) {
      invoke();
    } else {
      lastArgs = args;
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          if (lastArgs) {
            invoke();
            lastArgs = null;
          }
        }, limit - (now - lastCall));
      }
    }
  };
}


// ------------ Object utils ------------

/**
 * Updates a reactive object without replacing its reference, preserving deep watchers.
 *
 * @param target - The reactive object to be updated.
 * @param source - The new values to merge into the target object.
 */
export function updateReactiveObject(target: any, source: any) {
  Object.keys(source).forEach((key) => {
    const sourceValue = source[key];
    const targetValue = target[key];

    if (
      typeof sourceValue === 'object' &&
      sourceValue !== null &&
      !Array.isArray(sourceValue) &&
      typeof targetValue === 'object' &&
      targetValue !== null &&
      !Array.isArray(targetValue)
    ) {
      // Recursively merge nested objects (but not arrays)
      updateReactiveObject(targetValue, sourceValue);
    } else {
      // Assign primitive values and arrays directly
      target[key] = sourceValue;
    }
  });
}

export function clearReactiveObject(target: any) {
  Object.keys(target).forEach(key => delete target[key as keyof any]);
}

export function parseJsonSafely(value: any) {
  try {
    if (typeof value === 'object') return value;
    return JSON.parse(value);
  } catch (error) {
    console.warn("Failed to parse JSON:", value);
    return null; // Or a default value like {}
  }
}

/** Message for a `{ success: false, errors }` API response; errors may be strings or `{ message }` objects. */
export function getSubmissionErrorMessage(errors: unknown, fallback: string): string {
  if (!Array.isArray(errors)) return fallback;
  const messages = errors
    .map((error: any) => typeof error === 'string' ? error : error?.message)
    .filter(Boolean);
  return messages.length ? messages.join(' ') : fallback;
}

/**
 * Creates a debounced function that delays the execution of `fn` until after `delay` milliseconds 
 * have elapsed since the last time the debounced function was invoked.
 *
 * @param fn - The function to debounce.
 * @param delay - The number of milliseconds to delay.
 * @returns A new debounced function.
 *
 * @example
 * const search = debounce((query) => console.log('Searching:', query), 500);
 * search('hello'); // Will execute after 500ms if no other calls are made
 */
export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function(this: any, ...args: Parameters<T>) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}


// -------- Objects related utils -------- START
export async function overwriteObject<
  TargetT extends object = object
>(
  target: TargetT,
  newValues: TargetT
) {
  clearObject(target);
  Object.assign(target, newValues);
}

export async function clearObject<
  T extends object
>(target: T) {
  Object.keys(target).forEach(key => delete target[key as keyof T]);
}

/**
 * Calendar-day date helpers. Always local time — never `toISOString().split('T')`,
 * which is UTC and shifts the day for negative-offset timezones (off-by-one bug).
 */

/** Date -> "YYYY-MM-DD" using the local calendar day. */
export function toYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** "YYYY-MM-DD" -> local calendar midnight. Returns undefined for empty/invalid input. */
export function ymdToLocalDate(ymd: string | undefined): Date | undefined {
  if (!ymd?.trim()) return undefined;
  const parts = ymd.trim().split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return undefined;
  const [y, m, d] = parts;
  return new Date(y, m - 1, d);
}

/** Today as "YYYY-MM-DD" in local time. */
export function todayYmd(): string {
  return toYmd(new Date());
}

/**
 * A picked calendar day -> the UTC instant its local day starts / ends. Every widget
 * on one screen must share these, or the same picked range becomes two windows an
 * offset apart. Returns '' for empty/invalid input so callers can skip the request.
 */
export function ymdToUtcDayStart(ymd: string | undefined): string {
  const d = ymdToLocalDate(ymd);
  return d ? d.toISOString() : '';
}

export function ymdToUtcDayEnd(ymd: string | undefined): string {
  const d = ymdToLocalDate(ymd);
  if (!d) return '';
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}

/**
 * Bounds for APIs that bucket by UTC calendar day and floor whatever bounds they get
 * (/metrics/offline-devices). The picked day is a calendar date, so it maps to the SAME
 * date at UTC midnight — deriving these from local midnight instead would floor back
 * into the previous UTC day east of UTC, shifting the whole window a day early.
 * The window is half-open, so the end is the day AFTER the picked one.
 */
export function ymdToUtcCalendarStart(ymd: string | undefined): string {
  return isYmd(ymd) ? `${ymd}T00:00:00.000Z` : '';
}

export function ymdToUtcCalendarEndExclusive(ymd: string | undefined): string {
  if (!isYmd(ymd)) return '';
  const [y, m, d] = ymd!.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + 1)).toISOString();
}

function isYmd(ymd: string | undefined): boolean {
  return !!ymd && /^\d{4}-\d{2}-\d{2}$/.test(ymd.trim()) && !!ymdToLocalDate(ymd);
}
// -------- Objects related utils -------- END